// === Retention samples — photos kept against an EXISTING harvest task ===
//
// The capture flow never creates a harvest: the user picks one that already
// happened and adds photos to it. So the only thing written is a set of image
// rows pointing at a harvest_id.
//
// The "N Days" in the title is NOT stored. It is the gap between the harvest
// date (harvest_template.start_time) and captured_at, resolved on read — see
// apps/api/src/routes/harvest-retention-samples.ts.

import { z } from 'zod';

export const RetentionSampleImageInputSchema = z.object({
  image_path: z.string().min(1),
  note: z.string().nullable().optional(),
  /** When the photo was taken. Defaults to now if the client does not say. */
  captured_at: z.string().datetime().nullable().optional(),
  display_order: z.number().int().nullable().optional(),
});

export const RetentionSampleCreateSchema = z.object({
  harvest_id: z.number().int().positive(),
  images: z.array(RetentionSampleImageInputSchema).min(1),
});

export const RetentionSampleHarvestQuerySchema = z.object({
  block_type: z.string().min(1),
  block_name: z.string().min(1),
});

export type RetentionSampleImageInput = z.infer<typeof RetentionSampleImageInputSchema>;
export type RetentionSampleCreate = z.infer<typeof RetentionSampleCreateSchema>;
export type RetentionSampleHarvestQuery = z.infer<typeof RetentionSampleHarvestQuerySchema>;
